export default __webpack_public_path__ + "static/media/rules.6c4a2c2a.pdf";